import React, { FC } from 'react'

import { Page, PageContent } from 'common'
import { Header, InterSvgIcon } from 'components'
import { Button } from 'common/styles/layouts'

import { Text } from '@interco/inter-ui/components/Text'

import { ButtonContainer, MessageContainer } from '../styles'
import { TGenericFeedbackPageProps } from '../types'

export const GenericFeedbackPage: FC<TGenericFeedbackPageProps> = ({
  icon,
  iconColor,
  title,
  details,
  header,
  confirmButton,
  cancelButton,
  loading = false,
}) => (
  <Page>
    {header && (
      <Header title={header.title} goToPath={header.goToPath} showHomeIcon={header.showHomeIcon} />
    )}

    <PageContent>
      <MessageContainer>
        <InterSvgIcon iconRef={icon} height={64} width={64} color={iconColor} />
        <Text variant="headline-h1" color="typography" colorWeight={500} bold>
          {title}
        </Text>
        <Text variant="body-3" color="typography">
          {details}
        </Text>
      </MessageContainer>
      <ButtonContainer>
        <Button
          isLoading={loading}
          onClick={confirmButton.onClick}
          variant={confirmButton.variant ?? 'primary'}
          size={confirmButton.size ?? 'default'}
          fullWidth
        >
          {confirmButton.text}
        </Button>
        {cancelButton && (
          <Button
            onClick={cancelButton.onClick}
            variant={cancelButton.variant ?? 'secondary'}
            size={cancelButton.size ?? 'default'}
            fullWidth
          >
            {cancelButton.text}
          </Button>
        )}
      </ButtonContainer>
    </PageContent>
  </Page>
)
